export default "__VITE_ASSET__a7c7a160__"